import React from 'react';

import { Routes, Route } from 'react-router-dom';

import { EntryType } from 'components/registry/types/api';
import { BaseWrapper } from 'components/BaseWrapper';
import {
  GmoAddRequestPage,
  GmoRequestsEditPage,
  GmoRegistryEditPage,
  GmoInactiveEditPage,
  GmoRequestsViewPage,
  GmoRegistryViewPage,
  GmoInactiveViewPage,
} from 'modules/gmo/gmoForms/pages';
import { GmoRegistryPage, GmoRequestsPage, GmoInactivePage } from 'modules/gmo/gmoRegistry/pages';
import {
  GmProductAddRequestPage,
  GmProductRequestsEditPage,
  GmProductRegistryEditPage,
  GmProductInactiveEditPage,
  GmProductRequestsViewPage,
  GmProductRegistryViewPage,
  GmProductInactiveViewPage,
} from 'modules/gmProduct/gmProductForms/pages';
import {
  GmProductRegistryPage,
  GmProductRequestsPage,
  GmProductInactivePage,
} from 'modules/gmProduct/gmProductRegistry/pages';
import {
  FeedAdditiveAddRequestPage,
  FeedAdditiveEditRequestPage,
  FeedAdditiveEditRecordPage,
  FeedAdditiveViewRequestPage,
  FeedAdditiveViewRecordPage,
} from 'modules/feed/feedAdditive/pages';
import {
  ActiveSubstancesPage,
  ActivityKindsPage,
  AdverseReactionTypesPage,
  AnimalSpeciesPage,
  BusinessEntitiesPage,
  DrugAdministrationWaysPage,
  FeedAdditiveKindsPage,
  FeedAdditiveTypesPage,
  GmoResearchTypesPage,
  GmoUseTypesPage,
  InformationSourcePage,
  ManualChangesTypesPage,
  MeasuringUnitsPage,
  PharmGroupsPage,
  PharmPackagePage,
  PharmReleasePage,
  SigningPersonPage,
  SymptomsPage,
  UnitsPage,
} from 'modules/catalogs/pages';
import { FeedRequestsPage, FeedRegistryPage } from 'modules/feed/feedRegistry/pages';
import {
  PrescriptionPaperRegistryPage,
  PrescriptionRegistryPage,
  PrescriptionSearchPage,
} from 'modules/prescription/prescriptionRegistry/pages';
import * as AdversePetitions from 'modules/adversePetitions/adversePetitionsForms/pages';
import {
  AdversePetitionsRegistry,
  AdversePetitionsSearch,
} from 'modules/adversePetitions/adversePetitionsRegistry/pages';
import {
  PharmPermissionsRequestsPage,
  PharmPermissionsRegistryPage,
} from 'modules/pharmPermissions/pharmPermissionsRegistry/pages';
import {
  AddRequestPage,
  ViewRecordAndRequest,
  EditRecordAndRequest,
} from 'modules/pharmPermissions/pharmPermissionsForms/pages';
import {
  PrescriptionAddRecordPage,
  PrescriptionEditRecordPage,
  PrescriptionViewRecordPage,
  EditExtensionPeriodPage,
  AddExtensionPeriodPage,
  EditRequestCancelPage,
  AddRequestCancelPage,
  EditDispensingPage,
  AddDispensingPage,
} from 'modules/prescription/prescriptionForms/pages';
import { ConsignmentsRegistryPage } from 'modules/consignments/consignmentsRegistry/pages';
import {
  ConsignmentsAddPage,
  ConsignmentsEditPage,
  ConsignmentsViewPage,
  ConsigmentsCirculationEditPage,
  ConsigmentsCirculationAddPage,
} from 'modules/consignments/consignmentsForms/pages';
import {
  InspectorsAddPage,
  InspectorsEditPage,
  InspectorsViewPage,
} from 'modules/inspectors/inspectorsForms/pages';
import { InspectorsRegistryPage } from 'modules/inspectors/inspectorsRegistry/pages';
import { FakesAddPage, FakesEditPage, FakesViewPage } from 'modules/fakes/fakesForms/pages';
import { FakesRegistryPage } from 'modules/fakes/fakesRegistry/pages';
import { SystemParametersPage } from 'modules/admin/systemParametersRegistry/pages';
import { SendTransactionsUtility } from 'modules/admin/sendTransactionsUtility/pages';
import { ServiceRequestsRegistry } from 'modules/admin/serviceRequestsRegistry/pages';
import { TaskControlPage } from 'modules/admin/taskControlRegistry/pages';
import { DpoRegistryPage } from 'modules/dpo/dpoRegistry/pages';
import { DpoAddPage, DpoEditPage, DpoViewPage } from 'modules/dpo/dpoForms/pages';
import { GmpRegistryPage } from 'modules/gmp/gmpRegistry/pages';
import {
  GmpAddRecord,
  GmpEditRecord,
  GmpViewProducerTransactions,
  GmpViewRecord,
} from 'modules/gmp/gmpForms/pages';
import { Page404 } from 'modules/page404';

export const AppRouter = () => (
  <BaseWrapper>
    <Routes>
      {/* Admin */}
      <Route path="/ac/systemParameters" element={<SystemParametersPage />} />
      <Route path="/ac/transactionsUtility" element={<SendTransactionsUtility />} />
      <Route path="/ac/taskControl" element={<TaskControlPage />} />
      <Route path="/ac/serviceRequests" element={<ServiceRequestsRegistry />} />

      {/* Catalogs */}
      <Route path="/catalogs/adverseReactionTypes" element={<AdverseReactionTypesPage />} />
      <Route path="/catalogs/animalSpecies" element={<AnimalSpeciesPage />} />
      <Route path="/catalogs/drugAdministrationWays" element={<DrugAdministrationWaysPage />} />
      <Route path="/catalogs/informationSource" element={<InformationSourcePage />} />
      <Route path="/catalogs/manualChangesTypes" element={<ManualChangesTypesPage />} />
      <Route path="/catalogs/symptoms" element={<SymptomsPage />} />
      <Route path="/catalogs/units" element={<UnitsPage />} />
      <Route path="/catalogs/pharmGroups" element={<PharmGroupsPage />} />
      <Route path="/catalogs/signingPersons" element={<SigningPersonPage />} />
      <Route path="/catalogs/feedTypes" element={<FeedAdditiveTypesPage />} />
      <Route path="/catalogs/feedKinds" element={<FeedAdditiveKindsPage />} />
      <Route path="/catalogs/activeSubstances" element={<ActiveSubstancesPage />} />
      <Route path="/catalogs/pharmRelease" element={<PharmReleasePage />} />
      <Route path="/catalogs/pharmPackage" element={<PharmPackagePage />} />
      <Route path="/catalogs/activityKinds" element={<ActivityKindsPage />} />
      <Route path="/catalogs/gmoUseTypes" element={<GmoUseTypesPage />} />
      <Route path="/catalogs/gmoReserchTypes" element={<GmoResearchTypesPage />} />
      <Route path="/catalogs/measuringUnits" element={<MeasuringUnitsPage />} />
      <Route path="/catalogs/business-entities/:id" element={<BusinessEntitiesPage />} />

      {/* Prescription */}
      <Route path="/registry/prescription/search" element={<PrescriptionSearchPage />} />
      <Route path="/registry/prescription/registry" element={<PrescriptionRegistryPage />} />
      <Route
        path="/registry/prescription/paper"
        element={<PrescriptionPaperRegistryPage isPaper />}
      />
      <Route path="/registry/prescription/registry/:id" element={<PrescriptionViewRecordPage />} />
      <Route
        path="/registry/prescription/paper/:id"
        element={<PrescriptionViewRecordPage isPaper />}
      />
      <Route
        path="/registry/prescription/registry/:id/edit"
        element={<PrescriptionEditRecordPage />}
      />
      <Route
        path="/registry/prescription/paper/:id/edit"
        element={<PrescriptionEditRecordPage isPaper />}
      />
      <Route path="/prescription/addRecord" element={<PrescriptionAddRecordPage />} />
      <Route path="/prescription/addPaperRecord" element={<PrescriptionAddRecordPage isPaper />} />
      <Route
        path="/registry/prescription/registry/:usageId/:id/:prescriptionType/editDispensing"
        element={<EditDispensingPage />}
      />
      <Route
        path="/registry/prescription/paper/:usageId/:id/:prescriptionType/editDispensing"
        element={<EditDispensingPage isPaper />}
      />
      <Route
        path="/registry/prescription/registry/:id/:prescriptionType/addDispensing"
        element={<AddDispensingPage />}
      />
      <Route
        path="/registry/prescription/paper/:id/:prescriptionType/addDispensing"
        element={<AddDispensingPage isPaper />}
      />
      <Route
        path="/registry/prescription/registry/:id/extPeriod/edit"
        element={<EditExtensionPeriodPage />}
      />
      <Route
        path="/registry/prescription/registry/:id/extPeriod/add"
        element={<AddExtensionPeriodPage />}
      />
      <Route
        path="/registry/prescription/registry/:id/cancel/request"
        element={<AddRequestCancelPage />}
      />
      <Route
        path="/registry/prescription/registry/:id/cancel/request/edit"
        element={<EditRequestCancelPage />}
      />

      {/* AdversePetitions */}
      <Route path="/adversePetitions/addRecord" element={<AdversePetitions.AddRecordPage />} />
      <Route path="/registry/adversePetitions/registry" element={<AdversePetitionsRegistry />} />
      <Route path="/registry/adversePetitions/search" element={<AdversePetitionsSearch />} />
      <Route
        path="/registry/adversePetitions/registry/:id"
        element={<AdversePetitions.ViewRecordPage />}
      />
      <Route
        path="/registry/adversePetitions/registry/:id/edit"
        element={<AdversePetitions.EditRecordPage />}
      />
      <Route
        path="/registry/adversePetitions/registry/:id/decision/accept"
        element={<AdversePetitions.AcceptRequestForDecisionPage />}
      />
      <Route
        path="/registry/adversePetitions/registry/:id/decision/reject"
        element={<AdversePetitions.RejectRequestForDecisionPage />}
      />
      <Route
        path="/registry/adversePetitions/registry/:id/decision/edit"
        element={<AdversePetitions.EditRequestForDecisionPage />}
      />
      <Route
        path="/registry/adversePetitions/registry/:id/requestInfo"
        element={<AdversePetitions.AddRequestInfoPage />}
      />
      <Route
        path="/registry/adversePetitions/registry/:id/requestInfo/edit"
        element={<AdversePetitions.EditRequestInfoPage />}
      />
      <Route
        path="/registry/adversePetitions/registry/:id/actionRequest"
        element={<AdversePetitions.EditActionRequestPage />}
      />
      <Route
        path="/registry/adversePetitions/registry/:id/actionInfo"
        element={<AdversePetitions.AddActionInfoPage />}
      />
      <Route
        path="/registry/adversePetitions/registry/:id/actionInfo/edit"
        element={<AdversePetitions.EditActionInfoPage />}
      />
      <Route
        path="/registry/adversePetitions/registry/:id/prolongationRequest"
        element={<AdversePetitions.AddRequestProlongationInfoPage />}
      />
      <Route
        path="/registry/adversePetitions/registry/:id/prolongationRequest/edit"
        element={<AdversePetitions.EditRequestProlongationInfoPage />}
      />
      <Route
        path="/registry/adversePetitions/registry/:id/prolongation/accept"
        element={<AdversePetitions.AcceptProlongationPage />}
      />
      <Route
        path="/registry/adversePetitions/registry/:id/prolongation/reject"
        element={<AdversePetitions.RejectProlongationPage />}
      />
      <Route
        path="/registry/adversePetitions/registry/:id/vgnkiRequest"
        element={<AdversePetitions.AddRequestVGNKIPage />}
      />
      <Route
        path="/registry/adversePetitions/registry/:id/vgnkiRequest/edit"
        element={<AdversePetitions.EditRequestVGNKIPage />}
      />
      <Route
        path="/registry/adversePetitions/registry/:id/vgnkiDecision"
        element={<AdversePetitions.AddVGNKIDecisionPage />}
      />
      <Route
        path="/registry/adversePetitions/registry/:id/vgnkiDecision/edit"
        element={<AdversePetitions.EditVGNKIDecisionPage />}
      />
      <Route
        path="/registry/adversePetitions/registry/:id/reviewResult"
        element={<AdversePetitions.AddReviewResultPage />}
      />
      <Route
        path="/registry/adversePetitions/registry/:id/reviewResult/edit"
        element={<AdversePetitions.EditReviewResultPage />}
      />

      {/* Consignments */}
      <Route path="/registry/consignments/add" element={<ConsignmentsAddPage />} />
      <Route path="/registry/consignments/registry" element={<ConsignmentsRegistryPage />} />
      <Route path="/registry/consignments/registry/:id" element={<ConsignmentsViewPage />} />
      <Route path="/registry/consignments/registry/:id/edit" element={<ConsignmentsEditPage />} />
      <Route
        path="/registry/consignments/registry/:id/circulation/:action"
        element={<ConsigmentsCirculationAddPage />}
      />
      <Route
        path="/registry/consignments/registry/:id/circulation/:circulationId/:action"
        element={<ConsigmentsCirculationEditPage />}
      />

      {/* Gmo */}
      <Route path="/gmo/addRequest" element={<GmoAddRequestPage />} />
      <Route
        path="/registry/gmo/requests"
        element={<GmoRequestsPage entryType={EntryType.requests} />}
      />
      <Route
        path="/registry/gmo/registry"
        element={<GmoRegistryPage entryType={EntryType.registry} />}
      />
      <Route
        path="/registry/gmo/inactive"
        element={<GmoInactivePage entryType={EntryType.inactive} />}
      />
      <Route
        path="/registry/gmo/requests/:id"
        element={<GmoRequestsViewPage entryType={EntryType.requests} />}
      />
      <Route
        path="/registry/gmo/registry/:id"
        element={<GmoRegistryViewPage entryType={EntryType.registry} />}
      />
      <Route
        path="/registry/gmo/inactive/:id"
        element={<GmoInactiveViewPage entryType={EntryType.inactive} />}
      />
      <Route
        path="/registry/gmo/requests/:id/edit"
        element={<GmoRequestsEditPage entryType={EntryType.requests} />}
      />
      <Route
        path="/registry/gmo/registry/:id/edit"
        element={<GmoRegistryEditPage entryType={EntryType.registry} />}
      />
      <Route
        path="/registry/gmo/inactive/:id/edit"
        element={<GmoInactiveEditPage entryType={EntryType.inactive} />}
      />

      {/* GmProduct */}
      <Route path="/gmProduct/addRequest" element={<GmProductAddRequestPage />} />
      <Route
        path="/registry/gmProduct/requests"
        element={<GmProductRequestsPage entryType={EntryType.requests} />}
      />
      <Route
        path="/registry/gmProduct/registry"
        element={<GmProductRegistryPage entryType={EntryType.registry} />}
      />
      <Route
        path="/registry/gmProduct/inactive"
        element={<GmProductInactivePage entryType={EntryType.inactive} />}
      />
      <Route
        path="/registry/gmProduct/requests/:id"
        element={<GmProductRequestsViewPage entryType={EntryType.requests} />}
      />
      <Route
        path="/registry/gmProduct/registry/:id"
        element={<GmProductRegistryViewPage entryType={EntryType.registry} />}
      />
      <Route
        path="/registry/gmProduct/inactive/:id"
        element={<GmProductInactiveViewPage entryType={EntryType.inactive} />}
      />
      <Route
        path="/registry/gmProduct/requests/:id/edit"
        element={<GmProductRequestsEditPage entryType={EntryType.requests} />}
      />
      <Route
        path="/registry/gmProduct/registry/:id/edit"
        element={<GmProductRegistryEditPage entryType={EntryType.registry} />}
      />
      <Route
        path="/registry/gmProduct/inactive/:id/edit"
        element={<GmProductInactiveEditPage entryType={EntryType.inactive} />}
      />

      {/* Feed */}
      <Route path="/feed/addRequest" element={<FeedAdditiveAddRequestPage />} />
      <Route path="/registry/feed/requests" element={<FeedRequestsPage />} />
      <Route path="/registry/feed/registry" element={<FeedRegistryPage />} />
      <Route path="/registry/feed/requests/:id" element={<FeedAdditiveViewRequestPage />} />
      <Route path="/registry/feed/registry/:id" element={<FeedAdditiveViewRecordPage />} />
      <Route path="/registry/feed/requests/:id/edit" element={<FeedAdditiveEditRequestPage />} />
      <Route path="/registry/feed/registry/:id/edit" element={<FeedAdditiveEditRecordPage />} />

      {/* PharmPermissions */}
      <Route path="/pharmPermissions/addRequest" element={<AddRequestPage />} />
      <Route
        path="/registry/pharmPermissions/requests"
        element={<PharmPermissionsRequestsPage />}
      />
      <Route
        path="/registry/pharmPermissions/registry"
        element={<PharmPermissionsRegistryPage />}
      />
      <Route path="/registry/pharmPermissions/requests/:id" element={<ViewRecordAndRequest />} />
      <Route
        path="/registry/pharmPermissions/requests/:id/edit"
        element={<EditRecordAndRequest />}
      />
      <Route path="/registry/pharmPermissions/registry/:id" element={<ViewRecordAndRequest />} />
      <Route
        path="/registry/pharmPermissions/registry/:id/edit"
        element={<EditRecordAndRequest />}
      />

      {/* Dpo */}
      <Route path="/dpo/addDpo" element={<DpoAddPage />} />
      <Route path="/registry/dpo/registry/:id" element={<DpoViewPage />} />
      <Route path="/registry/dpo/registry" element={<DpoRegistryPage />} />
      <Route path="/registry/dpo/registry/:id/edit" element={<DpoEditPage />} />

      {/* Gmp */}
      <Route path="/gmp/addGmp" element={<GmpAddRecord />} />
      <Route path="/registry/gmp/registry" element={<GmpRegistryPage />} />
      <Route path="/registry/gmp/registry/:id" element={<GmpViewRecord />} />
      <Route path="/registry/gmp/registry/:id/edit" element={<GmpEditRecord />} />
      <Route
        path="/registry/gmp/registry/:id/producerTransactions"
        element={<GmpViewProducerTransactions />}
      />

      {/* Inspectors */}
      <Route path="/inspectors/add" element={<InspectorsAddPage />} />
      <Route path="/registry/inspectors/registry" element={<InspectorsRegistryPage />} />
      <Route path="/registry/inspectors/registry/:id" element={<InspectorsViewPage />} />
      <Route path="/registry/inspectors/registry/:id/edit" element={<InspectorsEditPage />} />

      {/* Fakes */}
      <Route path="/fakes/add" element={<FakesAddPage />} />
      <Route path="/registry/fakes/registry" element={<FakesRegistryPage />} />
      <Route path="/registry/fakes/registry/:id" element={<FakesViewPage />} />
      <Route path="/registry/fakes/registry/:id/edit" element={<FakesEditPage />} />

      <Route path="*" element={<Page404 />} />
    </Routes>
  </BaseWrapper>
);
